export const Administration_Wing = [
  { title: "University Administration", link: "https://jntugv.edu.in/administration" },
  { title: "Academic Audit", link: "https://daa.jntugv.edu.in/directorate/academic-audit-planning" },
  { title: "Examination Cell", link: "https://exams.jntugv.edu.in/" },
  { title: "Directorate of Admissions", link: "https://dap.jntugv.edu.in/" },
  { title: "IQAC Cell", link: "https://iqac.jntugv.edu.in/" },
  { title: "Research & Development", link: "https://drnd.jntugv.edu.in/" },
];

export const Online_Courses = [
  { title: "SWAYAM NPTEL", link: "https://swayam.gov.in" },
  { title: "Coursera Partnerships", link: "#" },
  { title: "Digital Library Access", link: "https://jntugv.edu.in/library" },
];
